export function getLanguage() {
  let langLoc
  if (localStorage.getItem('language') == 'portuguese') {
    langLoc = 'pt'
  } else if (localStorage.getItem('language') == 'english') {
    langLoc = 'en'
  } else if (localStorage.getItem('language') == 'english-uk') {
    langLoc = 'en-GB'
  } else if (localStorage.getItem('language') == 'german') {
    langLoc = 'de'
  } else if (localStorage.getItem('language') == 'spanish') {
    langLoc = 'es'
  } else if (localStorage.getItem('language') == 'french') {
    langLoc = 'fr'
  } else if (localStorage.getItem('language') == '日本語') {
    langLoc = 'ja'
  } else if (localStorage.getItem('language') == 'arabic') {
    langLoc = 'ar'
  } else if (localStorage.getItem('language') == 'dutch') {
    langLoc = 'nl'
  } else if (localStorage.getItem('language') == 'italian') {
    langLoc = 'it'
  } else if (localStorage.getItem('language') == 'mandarin') {
    langLoc = 'zh'
  } else if (localStorage.getItem('language') == 'hindi') {
    langLoc = 'hi'
  } else if (localStorage.getItem('language') == 'vietnamese') {
    langLoc = 'vi'
  } else if (localStorage.getItem('language') == 'thai') {
    langLoc = 'th'
  } else if (localStorage.getItem('language') == 'filipino') {
    langLoc = 'fil'
  }
  return langLoc
}

export const getBundleTranslation = (bundle, key) => {
  const lng = getLanguage() || 'en';
  let translations = null;
  if (bundle && Array.isArray(bundle.rows)) {
    const entry = bundle.rows.find((r) => r && r.key_name === key);
    translations = entry && entry.translations;
  } else if (bundle && bundle.content && bundle.content[key]) {
    translations = bundle.content[key].translations; // legacy shape
  }
  if (!translations) return '';
  if (lng === 'en' || lng === 'en-US') {
    return translations['en-US'] || translations['en'] || translations['core'] || '';
  }
  return translations[lng] || translations['core'] || '';
}

export const getPageTranslation = (bundle, pageName, key) => {
  if (!key) return '';
  return getBundleTranslation(bundle, pageName + '.' + key) || getBundleTranslation(bundle, key);
}